import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ChangePasswordPage: React.FC = () => {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (newPassword.length < 12) {
      setError('Новый пароль должен содержать минимум 12 символов');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Подтверждение пароля не совпадает');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      await changePassword(currentPassword, newPassword);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось изменить пароль');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-lg rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md shadow-2xl p-8">
        <div className="mb-8">
          <div className="text-xs uppercase tracking-[0.28em] text-amber-300/80 mb-3">Password rotation required</div>
          <h1 className="text-3xl font-semibold tracking-tight">Смена стартового пароля</h1>
          <p className="mt-3 text-sm text-slate-300">
            Аккаунт <span className="font-semibold text-white">{user?.displayName || user?.username}</span> использует bootstrap-пароль.
            Продолжить работу можно только после установки нового секрета.
          </p>
        </div>

        <form className="space-y-5" onSubmit={handleSubmit}>
          <label className="block">
            <span className="block text-sm font-medium text-slate-200 mb-2">Текущий пароль</span>
            <input
              type="password"
              className="w-full rounded-2xl border border-white/10 bg-slate-900/80 px-4 py-3 text-sm outline-none focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/30"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          <label className="block">
            <span className="block text-sm font-medium text-slate-200 mb-2">Новый пароль</span>
            <input
              type="password"
              className="w-full rounded-2xl border border-white/10 bg-slate-900/80 px-4 py-3 text-sm outline-none focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/30"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              autoComplete="new-password"
              required
            />
          </label>

          <label className="block">
            <span className="block text-sm font-medium text-slate-200 mb-2">Подтвердите пароль</span>
            <input
              type="password"
              className="w-full rounded-2xl border border-white/10 bg-slate-900/80 px-4 py-3 text-sm outline-none focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/30"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
              required
            />
          </label>

          {error ? (
            <div className="rounded-2xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-200">
              {error}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-2xl bg-cyan-400 text-slate-950 px-4 py-3 text-sm font-semibold transition hover:bg-cyan-300 disabled:opacity-60"
          >
            {submitting ? 'Сохраняем…' : 'Сменить пароль'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
